import { put, takeEvery } from "redux-saga/effects"
import {
  del,
  get,
  post,
  postImageAxios,
  postVideoAxios,
} from "helpers/api_helper"
import { getFormDataFromJSON, showToast } from "utils"
import { showSavingModal, hideSavingModal } from "../actions"
import {
  getMediaGalleryUsersSuccess,
  getMediaGallerySuccess,
  getMediaGalleryFailed,
  getMediaGalleryUsersFailed,
  getMediaGalleryDesignSuccess,
  getMediaGalleryDesignFailed,
  deleteMediaGalleryItemSuccess,
  deleteMediaGalleryItemFailed,
  updateMediaGalleryDesignSuccess,
  updateMediaGalleryDesignFailed,
  getLandingGallerySuccess,
  getLandingGalleryFailed,
  getMediaGalleryListSuccess,
  getMediaGalleryListFailed,
  uploadEventMediaSuccess,
  uploadEventMediaFailed,
  uploadLandingMediaFailed,
  uploadLandingMediaSuccess,
  deleteLandingMediaSuccess,
  deleteLandingMediaFailed,
  updateMediaCaptionFailed,
  updateMediaCaptionSuccess,
  getFlaggedMediaFailed,
  getFlaggedMediaSuccess,
  deleteMediaReportFailed,
  deleteMediaReportSuccess,
} from "./actions"
import {
  DELETE_LANDING_MEDIA,
  DELETE_MEDIA_GALLERY_ITEM,
  DELETE_MEDIA_REPORT,
  GET_FLAGGED_MEDIA,
  GET_LANDING_GALLERY,
  GET_MEDIA_GALLERY,
  GET_MEDIA_GALLERY_DESIGN,
  GET_MEDIA_GALLERY_LIST,
  GET_MEDIA_GALLERY_USERS,
  UPDATE_MEDIA_CAPTION,
  UPDATE_MEDIA_GALLERY_DESIGN,
  UPLOAD_EVENT_MEDIA,
  UPLOAD_LANDING_MEDIA,
} from "./actionTypes"

function* getMediaGallery({ payload: params }) {
  try {
    const response = yield get(`/event/${params.event_id}/gallery`, {
      params: { menu_item_id: params?.menu_item_id },
    })
    const userIds = []
    response.forEach(img => {
      if (!userIds.includes(img.file.user_id)) {
        userIds.push(img.file.user_id)
      }
    })
    const usersResponse = yield post("/users", { user_ids: userIds })
    yield put(getMediaGalleryUsersSuccess(usersResponse))
    yield put(getMediaGallerySuccess(response))
  } catch (error) {
    yield put(getMediaGalleryFailed(error))
  }
}

function* getMediaGalleryUsers({ payload: params }) {
  try {
    const response = yield post("/users", params)
    yield put(getMediaGalleryUsersSuccess(response))
  } catch (error) {
    yield put(getMediaGalleryUsersFailed(error))
  }
}

function* getMediaGalleryDesign({ payload: params }) {
  try {
    const response = yield get("/gallery/design", { params })
    yield put(getMediaGalleryDesignSuccess(response))
  } catch (error) {
    yield put(getMediaGalleryDesignFailed(error))
  }
}

function* deleteMediaGalleryItem({ payload: params }) {
  try {
    const response = yield del(
      `/admin/event/${params?.data?.event_id}/gallery`,
      {
        ids: params?.data?.ids,
      }
    )
    if (params?.callback) {
      params.callback()
    }
    yield put(deleteMediaGalleryItemSuccess(params?.data))
    showToast("success", "Gallery item deleted!", "Success")
  } catch (error) {
    showToast("error", error, "Error")
    yield put(deleteMediaGalleryItemFailed(error))
  }
}

function* updateMediaGalleryDesign({ payload: params }) {
  try {
    yield put(showSavingModal())
    const response = yield post("/admin/gallery/design", params)
    yield put(updateMediaGalleryDesignSuccess(response))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(updateMediaGalleryDesignFailed(error))
  }
}

function* getLandingGallery({ payload: params }) {
  try {
    const response = yield get(`/vendor/gallery`, { params })
    const userIds = []
    response.forEach(img => {
      if (!userIds.includes(img.file.user_id)) {
        userIds.push(img.file.user_id)
      }
    })
    const usersResponse = yield post("/users", { user_ids: userIds })
    yield put(getMediaGalleryUsersSuccess(usersResponse))
    yield put(getLandingGallerySuccess(response))
  } catch (error) {
    yield put(getLandingGalleryFailed(error))
  }
}

function* getMediaGalleryList({ payload: params }) {
  try {
    const response = yield get("/menu-items", { params })
    yield put(getMediaGalleryListSuccess(response))
  } catch (error) {
    yield put(getMediaGalleryListFailed(error))
  }
}

function* uploadEventMedia({ payload: params }) {
  try {
    yield put(showSavingModal())
    let media = []
    if (params?.imageParams?.files?.length > 0) {
      media = yield postImageAxios(
        `/event/${params?.notificationParams?.event_id}/galleries`,
        getFormDataFromJSON(params?.imageParams)
      )
    }
    if (params?.videoParams?.files?.length > 0) {
      media = yield postVideoAxios(
        `/event/${params?.notificationParams?.event_id}/galleries`,
        getFormDataFromJSON(params?.videoParams)
      )
    }
    yield post("/gallery/upload-notification", params?.notificationParams)
    const userIds = []
    media.forEach(img => {
      if (!userIds.includes(img.file.user_id)) {
        userIds.push(img.file.user_id)
      }
    })
    const usersResponse = yield post("/users", { user_ids: userIds })
    yield put(getMediaGalleryUsersSuccess(usersResponse))
    yield put(uploadEventMediaSuccess(media))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(uploadEventMediaFailed(error))
  }
}

function* uploadLandingMedia({ payload: params }) {
  try {
    yield put(showSavingModal())
    let media = []
    let image = []
    let video = []
    if (params?.imageParams?.files?.length > 0) {
      image = yield postImageAxios(
        "/file",
        getFormDataFromJSON(params?.imageParams)
      )
    }
    if (params?.videoParams?.files?.length > 0) {
      video = yield postVideoAxios(
        "/file",
        getFormDataFromJSON(params?.videoParams)
      )
    }
    media = yield post("/admin/vendor/gallery", {
      ...params?.featureParams,
      files: [...image, ...video],
    })
    const userIds = []
    media.forEach(img => {
      if (!userIds.includes(img.file.user_id)) {
        userIds.push(img.file.user_id)
      }
    })
    const usersResponse = yield post("/users", { user_ids: userIds })
    yield put(getMediaGalleryUsersSuccess(usersResponse))
    yield put(uploadLandingMediaSuccess(media))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(uploadLandingMediaFailed(error))
  }
}

function* deleteLandingMedia({ payload: params }) {
  try {
    const response = yield del("/admin/vendor/gallery", {
      ids: params?.data?.ids,
    })
    yield put(deleteLandingMediaSuccess(params?.data))
    if (params?.callback) {
      params.callback()
    }
  } catch (error) {
    showToast("error", error, "Error")
    yield put(deleteLandingMediaFailed(error))
  }
}

function* updateMediaCaption({ payload: params }) {
  try {
    const response = yield post("/gallery/caption", params)
    yield put(updateMediaCaptionSuccess(response))
  } catch (error) {
    yield put(updateMediaCaptionFailed(error))
    showToast("error", error, "Error")
  }
}

function* getFlaggedMedia({ payload: params }) {
  try {
    const response = yield get(`/flagged-media/${params?.id}`)
    yield put(getFlaggedMediaSuccess(response))
  } catch (error) {
    yield put(getFlaggedMediaFailed(error))
    showToast("error", error, "Error")
  }
}

function* deleteMediaReport({ payload: params }) {
  try {
    yield del(`/flagged-media/${params?.id}`)
    yield put(deleteMediaReportSuccess(params?.id))
    showToast("success", "Flag removed", "Success")
  } catch (error) {
    yield put(deleteMediaReportFailed(error))
    showToast("error", error, "Error")
  }
}

function* mediaGallerySaga() {
  yield takeEvery(GET_MEDIA_GALLERY, getMediaGallery)
  yield takeEvery(GET_MEDIA_GALLERY_USERS, getMediaGalleryUsers)
  yield takeEvery(GET_MEDIA_GALLERY_DESIGN, getMediaGalleryDesign)
  yield takeEvery(UPDATE_MEDIA_GALLERY_DESIGN, updateMediaGalleryDesign)
  yield takeEvery(DELETE_MEDIA_GALLERY_ITEM, deleteMediaGalleryItem)
  yield takeEvery(GET_LANDING_GALLERY, getLandingGallery)
  yield takeEvery(GET_MEDIA_GALLERY_LIST, getMediaGalleryList)
  yield takeEvery(UPLOAD_EVENT_MEDIA, uploadEventMedia)
  yield takeEvery(UPLOAD_LANDING_MEDIA, uploadLandingMedia)
  yield takeEvery(DELETE_LANDING_MEDIA, deleteLandingMedia)
  yield takeEvery(UPDATE_MEDIA_CAPTION, updateMediaCaption)
  yield takeEvery(GET_FLAGGED_MEDIA, getFlaggedMedia)
  yield takeEvery(DELETE_MEDIA_REPORT, deleteMediaReport)
}

export default mediaGallerySaga
